import type { CSSProperties } from 'react';
import { PROPERTY_CARD_BODY_STYLE } from '../../propertyCard/PropertyCardBodyContent';
import { PROPERTY_CARD_TITLE_STYLE } from '../../propertyCard/PropertyCardHeader';
import { Palette } from 'Palette';
import { BASE_TEXT_STYLE, FONT_MANROPE, HEADING_VARIANT_STYLE } from '../../styles/styles';

/**
 * Typography for the v2 editor's in-place fields, composed from the SAME
 * constants the rendered UI uses — not copied values. Changing the render
 * styling (font tokens, heading scale, `Palette.tone1`, the PropertyCard style
 * constants) changes these too, and vice-versa is impossible: there is one
 * source. Content blocks render at `tone1` (StandardHeaderText / ImageCarousel
 * default), so headings/body use `Palette.tone1.text`.
 */

const TONE1_TEXT = Palette.tone1.text;

export const webSectionHeadingSx: CSSProperties = {
  fontFamily: FONT_MANROPE,
  fontSize: HEADING_VARIANT_STYLE.heading2.fontSize,
  fontWeight: HEADING_VARIANT_STYLE.heading2.fontWeight,
  lineHeight: 1.3,
  color: TONE1_TEXT,
};

export const webBodySx: CSSProperties = {
  ...BASE_TEXT_STYLE,
  lineHeight: 1.6,
  color: TONE1_TEXT,
};

/**
 * Subtitle and Text blocks get their own entries so they can be restyled without
 * touching StandardHeaderText; they start out the same as its heading and body.
 */
export const webSubtitleSx: CSSProperties = {
  fontFamily: FONT_MANROPE,
  fontSize: HEADING_VARIANT_STYLE.heading2.fontSize,
  fontWeight: HEADING_VARIANT_STYLE.heading2.fontWeight,
  lineHeight: 1.3,
  color: TONE1_TEXT,
};

export const webTextSx: CSSProperties = {
  ...BASE_TEXT_STYLE,
  lineHeight: 1.6,
  color: TONE1_TEXT,
};

export const webCardTitleSx: CSSProperties = { ...PROPERTY_CARD_TITLE_STYLE };

export const webCardBodySx: CSSProperties = { ...PROPERTY_CARD_BODY_STYLE };

export const webListLabelSx: CSSProperties = {
  ...BASE_TEXT_STYLE,
  fontWeight: 600,
  lineHeight: 1.5,
  color: TONE1_TEXT,
};

export const webListValueSx: CSSProperties = {
  ...BASE_TEXT_STYLE,
  lineHeight: 1.5,
  color: TONE1_TEXT,
};

/**
 * The tag has no place in the rendered section body — it only labels the
 * investor-page filter pill — so it keeps a distinct editor-only "eyebrow" look.
 */
export const webTagSx: CSSProperties = {
  ...BASE_TEXT_STYLE,
  fontSize: '0.72rem',
  fontWeight: 700,
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
  color: '#8a8a8a',
};
